import projects from "../../data/projects.json"

<project-grid projects=projects />
